<template>
  <v-app >
    <v-card elevation="1" class="custom-card">
      <BaseHeader />

      <v-layout row wrap pb-3 class="main-wrapper">
        <PaymentDetails></PaymentDetails>
        <v-flex xs12 sm6 pa-3 pl-4>
          <v-flex class="pb-3 custom_text_18">
            {{ method }}
          </v-flex>

          <Paying :to="`/paymentInput/${this.$route.params.method}`"></Paying>

          <PayingScbEasy></PayingScbEasy>

          <change-payment-method />
        </v-flex>
      </v-layout>

      <BaseFooter :selected_payment_method="false"></BaseFooter>
    </v-card>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      method: ''
    }
  },
  mounted() {
    let billStatus = setInterval(() => {
      this.$store
        .dispatch('getBillDataStatus', this.$route.query.linkcode)
        .then(() => {
          if (this.$store.state.billDataStatus != 2) {
            let page =
              this.$store.state.billDataStatus <= 3
                ? 'paymentMethods'
                : 'billRecieve'
            clearInterval(billStatus)
            this.$router.push(
              `/${page}/?linkcode=${this.$route.query.linkcode}`
            )
          }
        })
    }, 10000)
    if (this.$store.state.billBank) {
      var bank = this.$store.state.billBank.filter(item => {
        return item.paymentType == this.$route.params.method
      })
      if (bank.length > 0) {
        let qr = {}
        switch (this.$route.params.method) {
          case 'SCB Easy':
            this.method = 'SCB Easy'
            qr.trantype = 'S'
            break
        }
        qr.method = this.$route.params.method
        qr.refcode = this.$store.state.linkcode
        qr.amount = this.$store.state.amount
        qr.bubankid = bank[0].id
        this.$store.dispatch('getScbEasyLink', qr)
      }
    } else {
      this.$router.push(
        '/paymentMethods/?linkcode=' + this.$route.query.linkcode
      )
    }
  },
  methods: {
    intervalOnProcess() {},
    getMobileOperatingSystem() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera
      if (
        userAgent.match(/iPad/i) ||
        userAgent.match(/iPhone/i) ||
        userAgent.match(/iPod/i)
      ) {
        return 'iOS'
      } else if (userAgent.match(/Android/i)) {
        return 'Android'
      } else {
        return 'unknown'
      }
    }
  }
}
</script>

<style scoped>
.v-input__slot .v-input--selection-controls__input i.v-icon {
  color: rgba(0, 0, 0, 0.57);
}
</style>
